<template>
  <div>
    <header class="home-header">
   
      <div class="main-center">
        <div class="user-box">
          <a target="_blank" :href="adminUrl">登录</a>
          <a target="_blank" :href="registerUrl">注册</a>
        </div>


        <!-- <div class="user-box" v-if="userInfo && userInfo.userName">
          用户:{{ userInfo.userName }}
        </div>
        <div class="user-box" @click="goLogIn" v-else>登录</div> -->
        <div>聊城市房地产中介机构监管服务平台</div>
        <div style="font-size: 16px">
          LIAOCHENG REAL ESTATE INTERMEDIARY SUPERVISION SERVICE PLATFORM
        </div>
      </div>
    </header>
    <div class="main-top-nav">
      <div class="main-center top-nav-box">
        <div
          class="main-nav-item"
          :class="{ active: type === item.code }"
          v-for="(item, index) in navList"
          :key="index"
          @click="jumpNav(item.url)"
        >
          {{ item.title }}
          <img
            v-if="item.childer && item.childer.length"
            class="main-nav-xiala"
            src="@/assets/img/xiala.png"
            alt=""
          />
          <template v-if="item.childer && item.childer.length">
            <div class="nav-childer-list">
              <div
                class="nav-childer-item"
                v-for="(cell, index) in item.childer"
                :key="index"
                @click="jumpNav(cell.url)"
              >
                {{ cell.title }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mainHeader",
  props: ["hasBanner", "type"],
  data() {
    return {
      adminUrl: process.env.VUE_APP_ADMIN_URL + '/',
      registerUrl: process.env.VUE_APP_ADMIN_URL + '/register',
      navList: [
        {
          title: "首页",
          bgColor: "#2eb7e6",
          url: "/",
          code: "index",
        },
        {
          title: "二手房",
          bgColor: "#2eb7e6",
          url: "/nstock",
          code: "nstock",
        },
        {
          title: "租赁房",
          bgColor: "#ffa44c",
          url: "/nrent",
          code: "nrent",
        },
        // {
        //   title: "经纪机构公示",
        //   bgColor: "#2eb7e6",
        //   url: "/company/list",
        //   code: "jggs",
        // },
        // {
        //   title: "经纪从业人员公示",
        //   bgColor: "#ffa44c",
        //   url: "/person/list",
        //   code: "cygs",
        // },
          {
          title: "中介管理",
          bgColor: "#fe6a6b",
          url: "/intermediary",
          code: "intermediary",
        },
        {
          title: "网签地点分布",
          bgColor: "#54c693",
          url: "/company/map",
          code: "wqdd",
        },
   

        {
          title: "挂牌房源公示",
          bgColor: "#54c693",
          url: "/resources/list",
          code: "resourcesList",
        },
           {
          title: "累计销售",
          bgColor: "#54c693",
          url: "/resources/salesList",
          code: "salesList",
        },
        {
          title: "服务评价公示",
          bgColor: "#54c693",
          url: "/remark/companyList",
          code: "companyRemark",
        },
      ],
      userInfo: {},
    };
  },
  methods: {
    goLogIn() {
      this.$router.push({
        path: "/logIn", //跳转的路径
      });
    },
    jumpIndex() {
      const jumpUrl = this.$router.resolve({ path: "/" });
      window.open(jumpUrl.href, "_blank");
    },

    jumpNav(url) {
      if (!url) return;
      const jumpUrl = this.$router.resolve({ path: url });
      window.open(jumpUrl.href, "_blank");
    },
  },
  mounted() {
    this.userInfo = this.$getUserInfo() || {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home-header {
  width: 100%;
  min-width: 1140px;
  height: 178px;
  background: url("../assets/img/banner.png") no-repeat;
  background-size: cover;
  font-size: 34px;
  color: #c3241c;
  font-weight: bold;
  display: flex;
  align-items: center;
  text-shadow: 0 0 0.3em #fff, 0 0 0.3em #fff, 0 0 0.3em #fff;
  position: relative;
}
.home-top-box {
  height: 30px;
  background: #F5F5F5;
  color: #6C6C6C;
  font-size: 12px;

}

.home-header .user-box {
    position: absolute;
    right: 0;
    top: 22px;
    font-size: 14px;
    color: #222;
    text-shadow: none;
    display: flex;
    align-items: center;
}
.home-header .user-box a {
    margin-left: 12px;
    color: #222;
    cursor: pointer;
}


.home-top-box .main-center {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.home-header .main-center {
  position: relative;
  height: 178px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.home-header .user-box {
  position: absolute;
  right: 0;
  top: 22px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  text-shadow: none;
}

.top-admin {
  font-size: 12px;
  color: #6C6C6C;
  cursor: pointer;
  text-shadow: none;
}

.home-header span {
  font-size: 16px;
}

.main-top-nav {
  width: 100%;
  min-width: 1140px;
  height: 50px;
  background: #b1191a;
  margin-bottom: 20px;
}
.top-nav-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main-nav-item {
  flex: 1;
  color: #fff;
  font-size: 15px;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  border-right: 1px solid rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 9;
}
.main-nav-xiala {
  margin-left: 4px;
  width: 16px;
}
.nav-childer-list {
  position: absolute;
  width: 162px;
  background: #b1191a;
  top: 50px;
  left: 0;
  display: none;
}
.main-nav-item:hover .nav-childer-list {
  display: block;
}
.main-nav-item:first-child {
  border-left: 1px solid rgba(255, 255, 255, 1);
}
.main-nav-item:hover {
  background: #9b2f3d;
}
.main-nav-item.active {
  background: #9b2f3d;
  font-weight: bold;
}
</style>
